import { render, staticRenderFns } from "./examPaperPreview.vue?vue&type=template&id=476da3e0&scoped=true&"
import script from "./examPaperPreview.vue?vue&type=script&lang=js&"
export * from "./examPaperPreview.vue?vue&type=script&lang=js&"
import style0 from "./examPaperPreview.vue?vue&type=style&index=0&id=476da3e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476da3e0",
  null
  
)

export default component.exports